var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "card card-primary" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-body pb-1" }, [
          _vm.unapprovedItems.length
            ? _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.unapprovedItems, function (item, index) {
                  return _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("student-identification-unapproved", {
                        attrs: { item: item, index: index, errors: _vm.errors },
                        on: { fetch: _vm.onFetch },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _c("div", { staticClass: "row" }, [_vm._m(1)]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "card card-primary collapsed-card" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "card-body pb-1" }, [
          _vm.submittedItems.length
            ? _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.submittedItems, function (item, index) {
                  return _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("student-identification-submitted", {
                        attrs: {
                          item: item,
                          index: index,
                          errors: _vm.errors,
                          logo: _vm.logo,
                        },
                        on: { fetch: _vm.onFetch },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _c("div", { staticClass: "row" }, [_vm._m(3)]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [_vm._v("Unapproved")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [
      _c("p", { staticClass: "text-center my-5" }, [
        _vm._v(
          "\n                            No information available.\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [_vm._v("Submitted")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-plus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [
      _c("p", { staticClass: "text-center my-5" }, [
        _vm._v(
          "\n                            No information available.\n                        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }